import type {ComponentProps} from "react";

import type {Button} from "@/components/ui/button";

import type {RunHelpTourOptions} from "./run-help-tour";

export type HelpTourPlacement = "list" | "sheet";

type ButtonSize = ComponentProps<typeof Button>["size"];
type ButtonVariant = ComponentProps<typeof Button>["variant"];

export type HelpTourPlacementConfig = {
  label: string;
  size: ButtonSize;
  variant: ButtonVariant;
  className: string;
  showBanner: boolean;
  restoreScroll: boolean;
};

export const HELP_TOUR_PLACEMENTS: Record<HelpTourPlacement, HelpTourPlacementConfig> = {
  list: {
    label: "Show me how",
    size: "icon",
    variant: "ghost",
    className: "text-muted-foreground hover:text-foreground shrink-0",
    showBanner: false,
    restoreScroll: true,
  },
  sheet: {
    label: "Show me how",
    size: "sm",
    variant: "outline",
    className: "h-8 shrink-0 px-2.5 text-xs",
    showBanner: false,
    restoreScroll: false,
  },
};

export function getHelpTourPlacementConfig(placement: HelpTourPlacement) {
  return HELP_TOUR_PLACEMENTS[placement];
}

export function resolveHelpTourRunOptions(
  placement: HelpTourPlacement | undefined,
  overrides: RunHelpTourOptions = {},
): RunHelpTourOptions {
  if (!placement) {
    return overrides;
  }

  const defaults = HELP_TOUR_PLACEMENTS[placement];
  return {
    showBanner: overrides.showBanner ?? defaults.showBanner,
    restoreScroll: overrides.restoreScroll ?? defaults.restoreScroll,
  };
}
